import AssetImageUpload from './AssetImageUpload';

export default AssetImageUpload;
